'use client';

import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export const ThemeSync = () => {
  const searchParams = useSearchParams();

  useEffect(() => {
    const themeParam = searchParams.get('theme');
    const validThemes = ['orange', 'blue', 'green', 'germen'];
    const selectedTheme =
      themeParam && validThemes.includes(themeParam) ? themeParam : 'germen';

    document.documentElement.setAttribute('data-theme', selectedTheme);
  }, [searchParams]);

  return null;
};
